const routerLocaleInfo = [
    {
        'es-ES': {
            storeCode: 'default',
            locale: 'es',
            countryCode: 'CL',
            storeLabel: 'Chile Store'
        }
    }
]

module.exports = routerLocaleInfo
